function BaseDB(name, options) {
  const self = this

  self.dbName = name
  self.isActive = false
  self.db = null
  self.loaded = false

  self.autoInit = options.autoInit || true

  self.key = options.key || 'key'
  self.dataKey = options.dataKey || 'data'
  self.indexedDataKey = options.dataKey || false
  self.version = options.version || 1
  self.indexList = options.indexList || []

  self.expireDuration = 30 * 24 * 60 * 60 * 1000 // default. 30일 후 만료.
  if (options.expireDuration != null) {
    self.expireDuration = options.expireDuration
  } else if (options.expireDuration === null) {
    self.expireDuration = null
  }

  // 내부에 메일 배열을 가지고 있도록 하여, 없는 것만 새로 DB에 추가하도록 처리(배열에도 함께 추가.).
  // 데이터를 가져가는 것은 배열에서 가져가도록 할 것.
  // 표시되는 메세지의 날짜에 맞춰서 적당히 가져가도록~!!
  self.dataMap = {}

  self.isInitialing = false;
  self.initWaitingReq = [];

  const init = () => {
    return new Promise((resolve, reject) => {
      if (self.isInitialing !== true) {
        self.isInitialing = true;

        const DBOpenRequest = window.indexedDB.open(self.dbName, self.version)

        DBOpenRequest.onerror = (error) => {
          console.log('error - db open failed', error)
          self.isActive = false
        }

        DBOpenRequest.onsuccess = (event) => {
          console.log('success - db open success.')

          self.db = event.target.result

          self
            .load()
            .then((ret) => {
              self.isActive = true

              self.initWaitingReq.forEach((promise) => {
                promise.resolve(ret);
              })
              self.initWaitingReq = []

              self.isInitialing = false
              resolve(ret)
            })
            .catch((err) => {
              self.initWaitingReq.forEach((promise) => {
                promise.reject(err);
              })
              self.initWaitingReq = []

              self.isInitialing = false
              reject(err)
            })
        }

        DBOpenRequest.onupgradeneeded = (event) => {
          const db = event.target.result

          db.onerror = (error) => {
            console.log('error - db upgrade.', error)
            self.isActive = false

            self.initWaitingReq.forEach((promise) => {
              promise.reject(error);
            })
            self.initWaitingReq = []

            self.isInitialing = false
            reject(error)
          }

          if (event.oldVersion === 1) {
            db.deleteObjectStore(self.dbName)
          }

          const objectStore = db.createObjectStore(self.dbName, { keyPath: self.key })
          // const objectStore = db.createObjectStore(self.dbName, { keyPath: 'url' })

          // objectStore.createIndex('conversationId', 'conversationId', { unique: true })
          if (self.expireDuration != null) {
            objectStore.createIndex('expireTime', 'expireTime', { unique: false })
          }
          // objectStore.createIndex('id', 'id', { unique: true })

          if (this.indexedDataKey === true) {
            objectStore.createIndex(self.dataKey, self.dataKey, { unique: false })
          }

          self.indexList.forEach((item) => {
            objectStore.createIndex(item, item, { unique: false })
          })
        }
      } else {
        self.initWaitingReq.push({
          resolve,
          reject,
        })
      }
    })
  }

  self.close = () => {
    if (self.isActive === true) {
      self.db.close()
    }
    self.isActive = false
  }

  self.isloading = false;
  self.loadWaitingReq = [];

  self.load = () => {
    return new Promise((resolve, reject) => {
      if (self.isloading !== true) {
        self.dataMap = {}
        self.isloading = true;
        if (self.expireDuration != null) {
          const transaction = self.db.transaction([self.dbName], 'readwrite')

          transaction.oncomplete = (tEvent) => {
            console.log('Transaction completed: database load finished.', tEvent)
          }

          transaction.onerror = (tEvent) => {
            console.log('Transaction not opened due to error.', tEvent)
            reject(tEvent)
          }

          const objectStore = transaction.objectStore(self.dbName)
          // const req = objectStore.openCursor()
          const index = objectStore.index('expireTime')

          // const keyRangeValue = IDBKeyRange.only(conversationId)
          const keyRangeValue = IDBKeyRange.upperBound(Date.now())
          const req = index.openCursor(keyRangeValue)
          req.onsuccess = (event) => {
            const cursor = event.target.result

            // 만료된 데이터 제거.
            if (cursor) {
              cursor.delete()
              cursor.continue()
            } else {
              self.loaded = true

              self.loadWaitingReq.forEach((promise) => {
                promise.resolve(true);
              })
              self.loadWaitingReq = []

              self.isloading = false

              resolve(true)
            }
          }

          req.onerror = (err) => {
            console.log('cursor read error.', err)
            self.loadWaitingReq.forEach((promise) => {
              promise.reject(true);
            })
            self.loadWaitingReq = []

            self.isloading = false

            reject(err)
          }
        } else {
          resolve(true)
        }
      } else {
        self.loadWaitingReq.push({
          resolve,
          reject,
        })
      }
    })
  }

  self.addData = (key, data) => {
    if (self.isActive !== true) {
      return Promise.resolve(null)
    }

    const promise = new Promise((resolve, reject) => {
      const transaction = self.db.transaction([self.dbName], 'readwrite')

      transaction.oncomplete = (tEvent) => {
        console.log('Transaction completed: database modification finished.', tEvent)
      }

      transaction.onerror = (error) => {
        console.log('Transaction not opened due to error. Duplicate items not allowed.', error)
      }

      const objectStore = transaction.objectStore(self.dbName)

      const newItem = {
        [self.key]: key,
        [self.dataKey]: data,
      }

      self.indexList.forEach((item) => {
        newItem[item] = data[item]
      })

      if (self.expireDuration != null) {
        newItem.expireTime = Date.now() + self.expireDuration
      }

      const objectStoreRequest = objectStore.add(newItem)

      objectStoreRequest.onsuccess = (event) => {
        console.log('Added successfully.', event)

        let item = newItem
        if (options.getSaveData != null) {
          item = options.getSaveData(newItem)
        }

        self.dataMap[key] = item

        resolve(self.dataMap[key])
      }

      objectStoreRequest.onerror = (error) => {
        console.log('failed to add.', error)
        reject(error)
      }
    })

    return promise
  }

  self.putData = (key, data) => {
    if (self.isActive !== true) {
      return Promise.resolve(null)
    }

    const promise = new Promise((resolve, reject) => {
      const transaction = self.db.transaction([self.dbName], 'readwrite')

      transaction.oncomplete = (tEvent) => {
        console.log('Transaction completed: database modification finished.', tEvent)
      }

      transaction.onerror = (error) => {
        console.log('Transaction not opened due to error. Duplicate items not allowed.', error)
      }

      const objectStore = transaction.objectStore(self.dbName)

      const newItem = {
        [self.key]: key,
        [self.dataKey]: data,
      }

      self.indexList.forEach((item) => {
        newItem[item] = data[item]
      })

      if (self.expireDuration != null) {
        newItem.expireTime = Date.now() + self.expireDuration
      }

      const objectStoreRequest = objectStore.put(newItem)

      objectStoreRequest.onsuccess = (event) => {
        console.log('Added successfully.', event)

        if (options.beforeRemoveSaveData != null) {
          options.beforeRemoveSaveData(self.dataMap[key])
        }

        let item = newItem
        if (options.getSaveData != null) {
          item = options.getSaveData(newItem)
        }

        self.dataMap[key] = item

        resolve(self.dataMap[key])
      }

      objectStoreRequest.onerror = (error) => {
        console.log('failed to add.', error)
        reject(error)
      }
    })

    return promise
  }

  self.deleteData = (key) => {
    if (self.isActive !== true) {
      return Promise.resolve(null)
    }

    const promise = new Promise((resolve, reject) => {
      if (self.dataMap[key] != null) {
        if (options.beforeRemoveSaveData != null) {
          options.beforeRemoveSaveData(self.dataMap[key])
        }

        delete self.dataMap[key]
      }

      const transaction = self.db.transaction([self.dbName], 'readwrite')

      transaction.oncomplete = (tEvent) => {
        console.log('Transaction completed: database modification finished.', tEvent)
      }

      transaction.onerror = (error) => {
        console.log('Transaction not opened due to error. Duplicate items not allowed.', error)
      }

      const objectStore = transaction.objectStore(self.dbName)

      const objectStoreRequest = objectStore.delete(key)

      objectStoreRequest.onsuccess = (event) => {
        console.log('Deleted successfully.', event)
        resolve(key)
      }

      objectStoreRequest.onerror = (error) => {
        console.log('failed to delete.', error)
        reject(error)
      }
    })

    return promise
  }

  self.clear = () => {
    if (self.isActive !== true) {
      return Promise.resolve(null)
    }

    const promise = new Promise((resolve, reject) => {
      if (options.beforeRemoveSaveData != null) {
        Object.values(self.dataMap).forEach((value) => {
          options.beforeRemoveSaveData(value)
        })
      }

      self.dataMap = {}

      const transaction = self.db.transaction([self.dbName], 'readwrite')

      transaction.oncomplete = (tEvent) => {
        console.log('Transaction completed: database modification finished.', tEvent)
      }

      transaction.onerror = (error) => {
        console.log('Transaction not opened due to error. Duplicate items not allowed.', error)
      }

      const objectStore = transaction.objectStore(self.dbName)

      const objectStoreRequest = objectStore.clear()

      objectStoreRequest.onsuccess = (event) => {
        console.log('cleared successfully.', event)
        resolve(true)
      }

      objectStoreRequest.onerror = (error) => {
        console.log('failed to clear.', error)
        reject(error)
      }
    })

    return promise
  }

  self.getData = (key) => {
    if (self.isActive !== true) {
      return Promise.resolve(null)
    }

    const promise = new Promise((resolve, reject) => {
      if (self.dataMap[key] != null) {
        resolve(self.dataMap[key])
      } else {
        const transaction = self.db.transaction([self.dbName], 'readonly')

        transaction.oncomplete = (tEvent) => {
          console.log('Transaction completed: database get finished.', tEvent)
        }

        transaction.onerror = (error) => {
          console.log('Transaction not opened due to error. Duplicate items not allowed.', error)
          reject(error)
        }

        const objectStore = transaction.objectStore(self.dbName)

        const objectStoreRequest = objectStore.get(key)

        objectStoreRequest.onsuccess = (event) => {
          console.log('get successfully.', event)

          const { result } = objectStoreRequest

          if (result != null) {
            let item = { ...result }
            if (options.getSaveData != null) {
              item = options.getSaveData(item)
            }

            self.dataMap[key] = item

            resolve(self.dataMap[key])
          } else {
            reject(new Error('No matching data.'))
          }
        }

        objectStoreRequest.onerror = (error) => {
          console.log('failed to get.', error)
          reject(error)
        }
      }
    })

    return promise
  }

  self.getAllData = () => {
    if (self.isActive !== true) {
      return Promise.resolve(null)
    }

    const promise = new Promise((resolve, reject) => {
      const transaction = self.db.transaction([self.dbName], 'readonly')

      transaction.oncomplete = (tEvent) => {
        console.log('Transaction completed: database get finished.', tEvent)
      }

      transaction.onerror = (error) => {
        console.log('Transaction not opened due to error. Duplicate items not allowed.', error)
        reject(error)
      }

      const objectStore = transaction.objectStore(self.dbName)

      const cursorRequest = objectStore.openCursor()

      const dataList = []
      cursorRequest.onsuccess = (event) => {
        const cursor = event.target.result
        if (cursor) {
          let item = { ...cursor.value }
          if (options.getSaveData != null) {
            item = options.getSaveData(item, cursor.key)
          }

          self.dataMap[cursor.key] = item
          if (options.checkForList == null || options.checkForList(item, cursor.key) === true) {
            dataList.push(item)
          }

          cursor.continue()
        } else {
          resolve({
            dataMap: self.dataMap,
            dataList,
          })
        }
      }

      cursorRequest.onerror = (error) => {
        console.log('failed to getAll.', error)
        reject(error)
      }
    })

    return promise
  }

  self.isLoaded = () => {
    return self.loaded
  }

  if (self.autoInit === true) {
    init()
  }

  self.getDB = async () => {
    if (this.isActive === true) {
      return Promise.resolve(true);
    }
    const initRes = await init();
    return initRes;
  }
}

export default BaseDB
